import { createTheme } from "@mui/material/styles";

export const ACCENT_GRADIENT =
  "linear-gradient(90deg, #6366f1, #a855f7, rgba(168,85,247,0))";

const theme = createTheme({
  palette: {
    mode: "dark",
    primary: {
      main: "#6366f1",
    },
    background: {
      default: "#0f172a",
      paper: "#1e293b",
    },
    error: {
      main: "#ef4444",
    },
    text: {
      primary: "#f1f5f9",
      secondary: "#94a3b8",
    },
  },
  shape: {
    borderRadius: 10,
  },
  typography: {
    h5: {
      fontWeight: 700,
      letterSpacing: "-0.02em",
    },
    h6: {
      fontWeight: 600,
      letterSpacing: "-0.01em",
    },
  },
  components: {
    MuiCssBaseline: {
      styleOverrides: {
        "html, body": {
          background:
            "linear-gradient(135deg, #1e1040 0%, #0f172a 50%, #0a1628 100%)",
          backgroundAttachment: "fixed",
          minHeight: "100vh",
        },
        "#root": {
          minHeight: "100vh",
        },
      },
    },
    MuiPaper: {
      defaultProps: {
        elevation: 0,
      },
      styleOverrides: {
        root: {
          backgroundImage: "none",
          background: "rgba(255, 255, 255, 0.05)",
          backdropFilter: "blur(20px)",
          WebkitBackdropFilter: "blur(20px)",
          border: "1px solid rgba(255, 255, 255, 0.08)",
          boxShadow:
            "0 8px 40px rgba(0, 0, 0, 0.4), inset 0 1px 0 rgba(255, 255, 255, 0.07)",
        },
      },
    },
    MuiButton: {
      styleOverrides: {
        root: {
          textTransform: "none",
          fontWeight: 600,
          borderRadius: 10,
          transition: "all 200ms ease",
        },
        containedPrimary: {
          boxShadow: "0 0 20px rgba(99, 102, 241, 0.3)",
          "&:hover": {
            boxShadow: "0 0 32px rgba(99, 102, 241, 0.55)",
            transform: "translateY(-1px)",
          },
          "&:active": {
            transform: "translateY(0)",
            boxShadow: "0 0 12px rgba(99, 102, 241, 0.3)",
          },
        },
        outlined: {
          borderColor: "rgba(255, 255, 255, 0.15)",
          "&:hover": {
            borderColor: "rgba(255, 255, 255, 0.35)",
            background: "rgba(255, 255, 255, 0.05)",
          },
        },
        outlinedPrimary: {
          borderColor: "rgba(99, 102, 241, 0.45)",
          "&:hover": {
            borderColor: "#6366f1",
            background: "rgba(99, 102, 241, 0.08)",
            boxShadow: "0 0 16px rgba(99, 102, 241, 0.2)",
          },
        },
      },
    },
    MuiOutlinedInput: {
      styleOverrides: {
        root: {
          borderRadius: 10,
          background: "rgba(255, 255, 255, 0.04)",
          transition: "all 200ms ease",
          "&.Mui-focused": {
            background: "rgba(255, 255, 255, 0.07)",
          },
          "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
            borderColor: "#6366f1",
            boxShadow: "0 0 0 3px rgba(99, 102, 241, 0.2)",
          },
          "&:hover .MuiOutlinedInput-notchedOutline": {
            borderColor: "rgba(255, 255, 255, 0.25)",
          },
        },
        notchedOutline: {
          borderColor: "rgba(255, 255, 255, 0.1)",
        },
      },
    },
    MuiInputLabel: {
      styleOverrides: {
        root: {
          color: "#64748b",
          "&.Mui-focused": {
            color: "#6366f1",
          },
        },
      },
    },
    MuiDivider: {
      styleOverrides: {
        root: {
          borderColor: "rgba(255, 255, 255, 0.06)",
        },
      },
    },
    MuiFormHelperText: {
      styleOverrides: {
        root: {
          color: "#475569",
        },
      },
    },
    MuiCircularProgress: {
      defaultProps: {
        color: "primary",
      },
    },
  },
});

export default theme;
